import { BodyText } from '@policygenius/mortar';
import { createUseStyles } from 'react-jss';

import Button from 'components/Button';

import styles from './styles';
import { ExplainerProps } from './types';

const useStyles = createUseStyles(styles);

const Explainer = ({ text, onLearnMore }: ExplainerProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <BodyText weight="bold">What is it?</BodyText>
      <BodyText>
        {text}
        {onLearnMore && (
          <>
            {' '}
            <Button
              className={classes.learnMore}
              onClick={onLearnMore}
              type="button"
              variant="tertiary"
            >
              Learn more
            </Button>
          </>
        )}
      </BodyText>
    </div>
  );
};

export default Explainer;
